import colors from './colors';

export const FONT_WEIGHT = 400;
export const FONT_WEIGHT_MEDIUM = 500;

export const textStyles = {
  base: {
    color: colors.black100,
    fontFamily: "'Special Gothic', sans-serif",
    fontWeight: FONT_WEIGHT,
    fontSize: '16px',
    lineHeight: '24px',
    display: 'inline-block',
    margin: 0,
  },
  h1: {
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: '24px',
    lineHeight: '32px',
  },
  h2: {
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: '20px',
    lineHeight: '28px',
  },
  h3: {
    fontWeight: FONT_WEIGHT_MEDIUM,
    fontSize: '16px',
    lineHeight: '24px',
  },
  body: {},
  bodySmall: {
    fontSize: '14px',
    lineHeight: '20px',
  },
  label: {
    fontSize: '12px',
    lineHeight: '16px',
  },
  labelSmall: {
    fontSize: '10px',
    lineHeight: '14px',
  },
};

export default textStyles;
